export default {
  get(name, path, component, meta, alias) {
    const route = {
      name,
      path,
      component,
      meta
    }
    if (alias && alias.name === name) {
      route.alias = alias.alias
    }
    return route
  }
}
